export default "__VITE_ASSET__JysQKIzM__"